export function getCurrencySymbol(lang: string) {
  switch (lang) {
    case 'fr':
      return '€'
    default:
      return '$'
  }
}
